<template>
  <div>
    <div class="header">
      <div class="container clearfix">
        <el-row class="PC">
          <el-col :span="20">
            <el-menu
              :default-active="activeIndex"
              :router="true"
              mode="horizontal">
              <el-menu-item index="/" @click="onSaveIndex('/')"><span>{{ lang === 'zh' ? '首页' : 'HOME' }}</span><el-divider direction="vertical"></el-divider></el-menu-item>
              <el-menu-item index="/bandStory" @click="onSaveIndex('/bandStory')"><span>{{ lang === 'zh' ? '品牌故事' : 'Band Story' }}</span><el-divider direction="vertical"></el-divider></el-menu-item>
              <el-menu-item @click="onToShop"><span>{{ lang === 'zh' ? '在线商城' : 'Online Mall' }}</span><el-divider direction="vertical"></el-divider></el-menu-item>
              <el-menu-item @click="onChangeLan" style="width: 110px;"><span>{{ lang === 'zh' ? 'English' : 'Chinese' }}</span></el-menu-item>
              <el-menu-item style="margin-top: 15px;margin-left: 10px;">
                <el-image
                  style="width: 47px; height: 47px"
                  :src="require('@/assets/images/black-logo.png')"
                  fit="fill"
                ></el-image>
              </el-menu-item>
            </el-menu>
          </el-col>
          <el-col :span="4">
            <div class="index-logo">
              <router-link to="/">
                <img src="@/assets/images/homePageLogo.png"/>
              </router-link>
            </div>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg Mobile" justify="space-between">
          <el-col :span="4" class="m-box">
            <div class="menu-btn" @click="mobileNav"><span></span><span></span><span></span></div>
          </el-col>
          <el-col :span="16" class="m-box m-index-logo" style="padding: 0">
            <router-link to="/">
              <img src="@/assets/images/homePageLogo.png">
            </router-link>
          </el-col>
          <el-col :span="4" class="m-box"></el-col>
        </el-row>
      </div>
    </div>
    <div :class="['mobile-nav',[mobile_nav?'m-nav-show':'m-nav-hide']]">
      <el-row>
        <el-col :span="12" style="padding-left: 20px">
          <img src="@/assets/images/homePageLogo.png">
        </el-col>
        <el-col :span="12" class="text-right" style="padding-right: 20px">
          <i class="el-icon-close" @click="mobileNav" style="color: #000000;font-size: 30px"></i>
        </el-col>
      </el-row>
      <el-menu
        :default-active="activeIndex"
        active-text-color="rgba(254, 196, 9, 1)"
        :router="true"
        class="el-menu-vertical-demo"
        background-color="transparent"
        text-color="#000"
        style="margin: 20px 0"
       >
        <el-menu-item index="/" class="m-menu-icon icon1" @click="onSaveIndex('/', 'mobile')">
          <span slot="title">{{ lang === 'zh' ? '首页' : 'HOME' }}</span>
        </el-menu-item>
        <el-menu-item index="/bandStory" class="m-menu-icon icon2" @click="onSaveIndex('/bandStory', 'mobile')">
          <span slot="title">{{ lang === 'zh' ? '品牌故事' : 'Band Story' }}</span>
        </el-menu-item>
        <el-menu-item class="m-menu-icon icon3" @click="onToShop">
          <span slot="title">{{ lang === 'zh' ? '在线商城' : 'Online Mall' }}</span>
        </el-menu-item>
        <el-menu-item @click="onChangeLan('mobile')" class="m-menu-icon icon4">
          <span slot="title">{{ lang === 'zh' ? 'English' : 'Chinese' }}</span>
        </el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default{
  name: 'Header',
  model: {
    props: 'value',
    event: 'update'
  },
  props: {
    lang: {
      type: String,
      default: 'zh'
    },
    value: {
      type: String,
      default: ''
    }
  },
  data(){
    return {
      mobile_nav: false,
      index: '/'
    }
  },
  computed: {
    activeIndex: {
      get: function() {
        return this.value
      },
      set: function(value) {
        this.$emit('update', value)
      }
    }
  },
  methods: {
    mobileNav(){
      this.mobile_nav = !this.mobile_nav
    },
    changePage (name) {
      if(name == 1){
        this.$router.push('/')
      }
    },
    onChangeLan(str) {
      // 手机端需要多触发隐藏效果
      if(str === 'mobile') {
        this.mobile_nav = !this.mobile_nav
      }
      this.activeIndex = this.index
      this.$emit('changLang')
    },
    onToShop() {
      this.activeIndex = this.index
      window.location.href = 'https://account.yitianyun.cn/wap/477/pages/index/index'
    },
    onSaveIndex(index, str='') {
      this.index = index
      // 手机端需要多触发隐藏效果
      if(str === 'mobile') {
        this.mobile_nav = !this.mobile_nav
      }
    }
  }
}
</script>

<style lang="less">
@import "../../style/global.less";
@import "../../style/common.less";
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue